export enum SubscriptionPlan {
    Basic = "Basic",
    // Advanced = "Разширен",
    // Full = "Пълен",
}